import getCsrfToken from "./getCsrfToken";

const verifyCsrf = (state = "{}") => {
  const receivedCsrf = JSON.parse(state).csrf;
  const expectedCsrf = getCsrfToken();
  if (!receivedCsrf || receivedCsrf !== expectedCsrf) {
    throw new Error("Social auth CSRF mismatch");
  }
};

export default verifyCsrf;
